import { render, staticRenderFns } from "./LayoutDetail.vue?vue&type=template&id=332c6560"
import script from "./LayoutDetail.vue?vue&type=script&lang=js"
export * from "./LayoutDetail.vue?vue&type=script&lang=js"
import style0 from "./LayoutDetail.vue?vue&type=style&index=0&id=332c6560&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports